module.exports = __webpack_public_path__ + "img/Playlist.2a945cc1.svg";